// extracted by mini-css-extract-plugin
export default {"select":"FormSelect_select__8sZt1","error":"FormSelect_error__rzxWp"};